import { render, staticRenderFns } from "./page8.vue?vue&type=template&id=30eeace8&scoped=true&"
import script from "./page8.vue?vue&type=script&lang=js&"
export * from "./page8.vue?vue&type=script&lang=js&"
import style0 from "./page8.vue?vue&type=style&index=0&id=30eeace8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30eeace8",
  null
  
)

export default component.exports